import { $Q, $Qll } from "../utils/query-selector";
import { dataToggle } from "../utils/toggle-dataset";

const setShortDescription = () => {
  const mainProductDescriptionShort = $Q('.main-product__description--short');

  if(!mainProductDescriptionShort) return;

  const description = mainProductDescriptionShort.innerHTML;
  mainProductDescriptionShort.innerHTML = description.split('...voir plus...')[0];
}

const setCompleteDescription = () => {
  const mainProductDescription = $Q('.main-product__description--large');

  if(!mainProductDescription) return;

  const description = mainProductDescription.innerHTML;

  mainProductDescription.innerHTML = description.split('...voir plus...').join('<br>');
}

const toggleDescription = () => {
  const mainProductDescriptionShort = $Q('.main-product__description');
  const mainProductViewmore = $Qll('.main-product__viewmore');

  mainProductViewmore.forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      dataToggle(mainProductDescriptionShort);

      if(mainProductDescriptionShort.dataset.active === "false") {
        window.scrollTo(0,0);
      }
    });
  });
};

setShortDescription();
setCompleteDescription();
toggleDescription();
